import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Col, Divider, Form, Input, Select } from 'antd';
import InputPrefixField from '../../../../../components/mobile/form-helpers/InputPrefixField';
import HeaderScreening from '../../../../../components/mobile/sign-up/HeaderScreening';

const heights = [
  {label: 'cm', value: 'cm'},
  {label: 'ft', value: 'ft'},
  {label: 'inch', value: 'inch'},
];

const weights = [
  {label: 'kg', value: 'kg'},
  {label: 'g', value: 'g'},
  {label: 'lbs', value: 'lbs'},
];

function MobileMeasurementsScreen({fieldName, step, count}) {
  const { t } = useTranslation(['medical-history', 'common']);
  const { values, setFieldValue } = useFormikContext();
  const defaultValueHeight = "cm"
  const defaultValueWeight = "kg"

  const handleChangeHeight = (e) => {
    const data = {...values[fieldName]}
    const height = {
      number: e.target.value,
      type: data?.height?.type ?? defaultValueHeight
    }
    data.height = height
    setFieldValue(fieldName, data)
  }

  const handleChangeHeightType = (value) => {
    const data = {...values[fieldName]}
    const height = {
      number: data?.height?.number ?? null,
      type: value
    }
    data.height = height
    setFieldValue(fieldName, data)
  }

  const handleChangeWeight = (e) => {
    const data = {...values[fieldName]}
    const weight = {
      number: e.target.value,
      type: data?.weight?.type ?? defaultValueWeight
    }
    data.weight = weight
    setFieldValue(fieldName, data)
  }

  const handleChangeWeightType = (value) => {
    const data = {...values[fieldName]}
    const weight = {
      number: data?.weight?.number ?? null,
      type: value
    }
    data.weight = weight
    setFieldValue(fieldName, data)
  }

  return (
    <>
      <HeaderScreening
        count={count}
        step={step}
        title={t('medical-history:measurements.title')}
        subtitle={t('medical-history:measurements.subtitle')}
      />
      <Divider />
      <Col xs={24}>
        <Form>
          <Form.Item
            name={["height", "number"]}
            label={t('medical-history:measurements.form.height.label')}
          >
            <Input
              style={{ width: '100%' }}
              onChange={handleChangeHeight}
              defaultValue={values[fieldName]?.height?.number}
              value={values[fieldName]?.height?.number}
              addonAfter={
                <Form.Item
                  name={["height", "type"]}
                  noStyle
                >
                  <Select defaultValue={values[fieldName]?.height?.type ?? defaultValueHeight} value={values[fieldName]?.height?.type ?? defaultValueHeight} options={heights} onChange={handleChangeHeightType} />
                </Form.Item>
              }
            />
          </Form.Item>
          <Form.Item
            name={["weight", "number"]}
            label={t('medical-history:measurements.form.weight.label')}
          >
            <Input
              style={{ width: '100%' }}
              onChange={handleChangeWeight}
              defaultValue={values[fieldName]?.weight?.number}
              value={values[fieldName]?.weight?.number}
              addonAfter={
                <Form.Item
                  name={["weight", "type"]}
                  noStyle
                >
                  <Select defaultValue={values[fieldName]?.weight?.type ?? defaultValueWeight} value={values[fieldName]?.weight?.type ?? defaultValueWeight} options={weights} onChange={handleChangeWeightType} />
                </Form.Item>
              }
            />
          </Form.Item>
        </Form>
      </Col>
    </>
  );
}

export default MobileMeasurementsScreen;
